import * as React from 'react';
import styled, { css } from 'styled-components';

import { color } from 'styles/utils';
import { CarouselContext } from './CarouselContext';

const StyledContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 100%;
`;

const StyledTab = styled.button`
  ${(p) =>
    p.$type &&
    {
      bullets: css`
        background-clip: content-box;
        background-color: currentcolor;
        border-radius: 50%;
        color: ${color('darkTeal')};
        font-size: 0.625rem;
        height: 2.5em;
        padding: 0.75em;
        width: 2.5em;

        &[aria-selected='true'] {
          color: ${color('white')};
        }
      `,
    }[p.$type]}
`;

export default function CarouselTabs({ children, type, ...props }) {
  const context = React.useContext(CarouselContext);

  if (!context) {
    // Handle error
    return null;
  }

  const { turn, state } = context;

  function getTabProps(index) {
    return {
      'aria-controls': state.slides?.[index]?.id,
      'aria-selected': state.current === index,
      key: state.slides?.[index]?.id,
      onClick: () => turn(index),
      type: 'button',
    };
  }

  return (
    <StyledContainer $type={children ? null : type} role="tablist" {...props}>
      {children
        ? React.Children.map(children, (child, index) => (
            <StyledTab {...getTabProps(index)}>{child}</StyledTab>
          ))
        : state.slides?.map((_, index) => (
            <StyledTab $type={type} {...getTabProps(index)} />
          ))}
    </StyledContainer>
  );
}

CarouselTabs.defaultProps = {
  type: 'bullets',
};
